import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../../configs/AppConfig";
import {AUTH_TIPE} from "../../constants/AuthConstant";

const  pengawasService = {}

pengawasService.data = function (token,data='') {
    return fetch({
        url: '/pengaturan/pengawas/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

pengawasService.show = function (token,data='') {
    return fetch({
        url: '/pengaturan/pengawas/show',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

pengawasService.data_import = function (token,data) {
    return fetch({
        url: '/pengaturan/pengawas/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pengawasService.empty_import = function (token,data) {
    return fetch({
        url: '/pengaturan/pengawas/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pengawasService.save_import = function (token,data) {
    return fetch({
        url: '/pengaturan/pengawas/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pengawasService.pengguna_pengawas = function (token,data='') {
    return fetch({
        url: '/ref/pengguna_pengawas',
        method: 'post',
        params: data,
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default pengawasService;
